"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_breakpoints_1 = __importDefault(require("react-breakpoints"));
var react_router_dom_1 = require("react-router-dom");
var client_1 = require("@apollo/client");
var Layout_1 = __importDefault(require("./components/Layout"));
var About_1 = __importDefault(require("./views/About"));
var Index_1 = __importDefault(require("./views/Index"));
var NotFound_1 = __importDefault(require("./views/NotFound"));
var environment_1 = __importDefault(require("./environment"));
var MusicRouter_1 = __importDefault(require("./views/MusicRouter"));
require("./static/theme/assets/sass/main.scss");
require("./static/images/ctm-resume.pdf");
require("./static/images/lassen.jpeg");
require("./static/images/avatar.png");
var client = new client_1.ApolloClient({
    uri: environment_1.default.apiUri,
    cache: new client_1.InMemoryCache(),
});
var breakpoints = {
    mobile: 0,
    large: 980,
};
function AppRouter() {
    return (react_1.default.createElement(client_1.ApolloProvider, { client: client },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(react_breakpoints_1.default, { breakpoints: breakpoints },
                react_1.default.createElement(Layout_1.default, null,
                    react_1.default.createElement(react_router_dom_1.Routes, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(Index_1.default, null) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/about/", element: react_1.default.createElement(About_1.default, null) }),
                        (0, MusicRouter_1.default)(),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(NotFound_1.default, null) })))))));
}
react_dom_1.default.render(react_1.default.createElement(AppRouter, null), document.getElementById('index'));
